import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "../components/legal-page";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <LegalPage title="Política de privacidade" updated="28 de setembro de 2026">
      <p>
        Esta política descreve quais dados o Bridge trata e por quê. É
        o texto operacional da plataforma — não substitui orientação jurídica
        específica da sua empresa.
      </p>

      <h2>Quem trata o quê</h2>
      <p>
        A conta do Bridge (e-mail, senha, nome, empresa) é tratada por nós, na
        qualidade de controlador, para prestar o serviço. Pedidos, compradores,
        anúncios e perguntas vêm do marketplace que você autorizou. Nesse
        recorte atuamos como operador: usamos esses dados só para exibir,
        sincronizar estoque e operar a loja no Bridge, sob a sua instrução.
      </p>

      <h2>O que coletamos</h2>
      <ul>
        <li>Dados da conta: nome, e-mail, senha (hash), aceite dos termos.</li>
        <li>
          Tokens de acesso das lojas, criptografados em repouso, para falar com
          o marketplace em seu nome.
        </li>
        <li>
          Catálogo operacional: pedidos, itens, envios, anúncios, perguntas e
          saldos de estoque.
        </li>
        <li>
          Dados de compradores que o marketplace nos entrega (nome e campos do
          pedido). Essas pessoas não se cadastram no Bridge.
        </li>
        <li>
          Cobrança: a Asaas recebe CPF/CNPJ e o pagamento. Nós guardamos a
          referência da assinatura e o status, não o cartão.
        </li>
        <li>Logs técnicos e de sincronização, para depurar falhas.</li>
      </ul>

      <h2>Base e finalidade</h2>
      <p>
        Tratamos esses dados para executar o contrato (operar a loja), cumprir
        obrigação legal quando couber (por exemplo, guarda mínima de registro
        de pagamento) e proteger a plataforma (segurança, abuso, suporte).
      </p>

      <h2>Compartilhamento</h2>
      <p>
        Compartilhamos o necessário com o marketplace autorizado, a Asaas (se
        você assinar), a Resend (e-mails transacionais) e a infraestrutura que
        hospeda o produto. Não vendemos lista de clientes.
      </p>

      <h2>Retenção e exclusão</h2>
      <p>
        Enquanto a organização estiver ativa, os dados operacionais ficam
        disponíveis no produto. Depois do cancelamento da assinatura, o acesso
        de sincronização cessa ao fim do período; a leitura permanece para você
        exportar o que precisar.
      </p>
      <p>
        Pedido de exclusão: escreva para o e-mail de suporte indicado no
        rodapé. Apagamos a organização, usuários, tokens, catálogo e logs
        associados em até 30 dias, salvo o que a lei exigir guardar (por
        exemplo, evidência de pagamento). Dados de compradores que só existiam
        no Bridge por causa da loja saem junto — o marketplace continua com a
        cópia original dele.
      </p>

      <h2>Seus direitos</h2>
      <p>
        Titulares podem pedir acesso, correção, anonimização, exclusão,
        portabilidade e informação sobre compartilhamentos, pela LGPD. Se o
        pedido for de um comprador da sua loja, encaminhe para nós e para o
        marketplace: a origem do dado é o canal de venda.
      </p>

      <h2>Sessão e cookies</h2>
      <p>
        Usamos cookie HttpOnly de sessão e preferência de tema no navegador.
        Quando o analytics está ligado, o Plausible registra pageviews e os
        eventos de cadastro e loja conectada — sem cookies e sem identificar
        a pessoa. Não usamos rede de anúncio de terceiros neste recorte.
      </p>
    </LegalPage>
  );
}
